// src/types/product.js
// Types for Product data structure (synced with AI8SAAT Extension)

// Empty prompt template helper
export const getEmptyPromptSet = () => ({
    promptImage: '',
    promptVideo: '',
    captionTiktok: ''
});

export const getEmptyPromptCollection = () => ({
    set1: getEmptyPromptSet(),
    set2: getEmptyPromptSet(),
    set3: getEmptyPromptSet()
});

export const createNewProduct = (name, link) => ({
    id: `prod_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
    name,
    link,
    imageBase64: null,
    prompts: getEmptyPromptCollection(),
    selectedSets: ['set1'],
    logs: []
});
